/**
 * Derive which UnifiedLoginView / LoginView step to show from auth footprint.
 * Bound store (cashier cleared or cold start) → pin; franchise only → store;
 * neither → franchise Welcome. Callers must not default to franchise before this.
 *
 * @param {{ StoreDB?: string }|null|undefined} defaultStore
 * @param {boolean} hasFranchiseAdmin
 * @returns {'pin'|'store'|'franchise'}
 */
export function resolveLoginStep(defaultStore, hasFranchiseAdmin) {
  if (defaultStore && defaultStore.StoreDB) {
    return 'pin';
  }
  if (hasFranchiseAdmin) {
    return 'store';
  }
  return 'franchise';
}

/**
 * True when admin record still has Welcome credentials (Switch Store / store-only leave).
 *
 * @param {object|null|undefined} admin
 * @returns {boolean}
 */
export function hasFranchiseCredentials(admin) {
  if (!admin) return false;
  const email = admin.email || admin.Email || admin.username || admin.Username;
  const password = admin.password || admin.Password;
  return !!(
    email && String(email).trim().length > 0 &&
    password && String(password).trim().length > 0
  );
}
